export const CHECK_IN_STATUSES = {
  success: 'SUCCESS',
  fail: 'FAIL',
  unknown: 'UNKNOWN',
}
